<template>
  <div>
    <el-dialog
      ref="addEditViewDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="h630_dialog abow_dialog"
      width="1300px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
    >
      <div
        v-loading="loading"
        :loading="loading"
        :element-loading-text="$t('detailPage.loading')"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-form
          ref="dialogAddEditViewForm"
          :model="dialogAddEditViewForm"
          :rules="eventType==='view' ? null : dialogAddEditViewFormRules"
          class="add-edit-view-form"
          @submit.native.prevent
        >
          <div class="modal-box">
            <h3 class="modal-title">
              基础信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item
                    label="省区"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.provinceName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="城市"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.cityName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="方案编号"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.schemeNo"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="方案名称"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.schemeName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="活动日期"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.activityDate"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="人员名称"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.employeeName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="活动场次"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.fieldTypeValue"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item
                    label="应发金额"
                    required
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.payableAmount"
                      disabled
                    >
                      <template slot="append">
                        元
                      </template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="实发金额"
                    required
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.paymentAmount"
                      :disabled="eventType === 'view'"
                      @input="(val)=>{limitNumber(val, dialogAddEditViewForm, 'paymentAmount')}"
                      @blur="setNumberValueDefaultZero($event, dialogAddEditViewForm, 'paymentAmount',2)"
                    >
                      <template slot="append">
                        元
                      </template>
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>

          <div class="modal-box">
            <h3 class="modal-title">
              备注信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="24">
                  <el-form-item prop="remark">
                    <el-input
                      v-model="dialogAddEditViewForm.remark"
                      type="textarea"
                      placeholder="备注"
                      :disabled="eventType==='view'"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-form>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          v-if="eventType!=='view'"
          type="primary"
          @click="handleSave"
        >
          保存
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// dialog 拖拽
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 设置input值为数字
import setNumberMixin from '@/mixin/setNumberMixin'
// API
import { viewSalaryExternalEmployeeSalaryInfoApi, saveSalaryExternalEmployeeSalaryInfoApi } from '@/api/v2/salaryExternalEmployeeSalaryInfo'

export default {
  components: {},
  mixins: [dialogDragMixin, setNumberMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      loading: true,
      dialogAddEditViewForm: {},
      dialogAddEditViewFormRules: {
        remark: [{ max: 128, message: '最多输入128个字符', trigger: 'blur' }]
      }
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        let _this = this;

        _this.loading = true

        _this.dialogAddEditViewForm = {}
        _this.loadData()

        _this.$nextTick(() => {
          _this.$refs.dialogAddEditViewForm.clearValidate()
        })
      }
    }
  },
  methods: {
    // 加载数据
    loadData () {
      let _this = this
      viewSalaryExternalEmployeeSalaryInfoApi({ id: _this.dataId }).then(res => {
        const { data } = res
        _this.dialogAddEditViewForm = data
        _this.loading = false
      })
    },
    totalAmountFun(){
      this.dialogAddEditViewForm.realPerformanceAmount = Number((Number(this.dialogAddEditViewForm.performanceAmount) - Number(this.dialogAddEditViewForm.deductAmount)).toFixed(2))
    },
    // 加载数据
    reloadData() {
      this.$emit('reloadData')
    },
    modalClose () {
      let _this = this;
      _this.$emit('update:dialogVisible', false)
      _this.$refs.dialogAddEditViewForm.clearValidate()
    },
    // 新增|修改保存
    handleSave() {
      this.totalAmountFun()
      this.$refs.dialogAddEditViewForm.validate(valid => {
        if (valid) {
          this.$confirm(
            '是否确定调整金额？', '系统提示',
            {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
              center: true
            }
          )
            .then(async () => {
              this.loading = true
              this.handlerSave()
            })
            .catch(() => { })
        }
      })
    },
    // 保存
    handlerSave() {
      let _this = this
      let params = {
        id: _this.dialogAddEditViewForm.id,
        paymentAmount: _this.dialogAddEditViewForm.paymentAmount,
        remark: _this.dialogAddEditViewForm.remark
      }
      saveSalaryExternalEmployeeSalaryInfoApi(params).then(() => {
        _this.loading = false
        _this.$message({ message: '保存成功', type: 'success' })
        _this.reloadData()
        _this.modalClose()
      }).catch(() => {
        _this.loading = false
      })
    }
  }
}
</script>
<style lang="scss"  scoped>
</style>
